import { useEffect, useState } from 'react';
import { publicApi } from '../api/client';

/**
 * Sous-services dynamiques : récupérés depuis l'API/DB.
 * Pas de fallback codé en dur — hors-ligne, ils sont indisponibles
 * (la commande en ligne est alors bloquée côté formulaire).
 */
export function useSubServices(parentSlug) {
  const [state, setState] = useState({ items: [], loading: !!parentSlug, offline: false });

  useEffect(() => {
    let alive = true;
    if (!parentSlug) {
      setState({ items: [], loading: false, offline: false });
      return () => { alive = false; };
    }
    setState((s) => ({ ...s, loading: true, offline: false }));
    publicApi.subServices(parentSlug)
      .then((res) => {
        if (alive) setState({ items: res.subServices || [], loading: false, offline: false });
      })
      .catch(() => {
        if (alive) setState({ items: [], loading: false, offline: true });
      });
    return () => { alive = false; };
  }, [parentSlug]);

  return state;
}

/**
 * Types de service depuis la base (collection `catalogtypes`).
 * Hors-ligne : indisponibles comme les sous-services.
 */
export function useCatalogTypes() {
  const [state, setState] = useState({ types: [], loading: true, offline: false });

  useEffect(() => {
    let alive = true;
    publicApi.catalog()
      .then((res) => {
        if (alive) setState({ types: res.types || [], loading: false, offline: false });
      })
      .catch(() => {
        if (alive) setState({ types: [], loading: false, offline: true });
      });
    return () => { alive = false; };
  }, []);

  return state;
}

/**
 * Langues actives du catalogue (collection `cataloglanguages`, importées
 * via API + activées/désactivées par l'admin).
 * Hors-ligne ou catalogue vide : liste vide — l'appelant garde son repli local.
 */
export function useCatalogLanguages() {
  const [state, setState] = useState({ languages: [], loading: true, offline: false });

  useEffect(() => {
    let alive = true;
    publicApi.catalog()
      .then((res) => {
        if (alive) setState({ languages: res.languages || [], loading: false, offline: false });
      })
      .catch(() => {
        if (alive) setState({ languages: [], loading: false, offline: true });
      });
    return () => { alive = false; };
  }, []);

  return state;
}
